













































































































































































import $ from 'jquery';
import ModalJourneyABM from '../../home/components/ModalJourneyABM.vue';
import {
    EventBus,
    hasElements,
    TypeEventBus,
    sortObjectByPropertyName,
    checkIfIDExistsInArray,
    getUniqueId,
    formatDate,
    getCurrentTime
} from '../../core/utils';
import { Destroyed } from '../../core/decorators';
import { Component, Prop, Mixins, Vue, Watch, Emit } from 'vue-property-decorator';
import { PRIVILEGE_KEYS, PRIVILEGE_TYPES } from '../../core/utils/privileges';
import {
    MsgBox,
    Combobox,
    PlusEyeButtons,
    Breadcrums,
    CloseConfirmationModal,
} from '../../core/components';
import Button from '../../core/components/Button.vue';
import {
    AuthStoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    StoreHelper,
    NotificationStoreHelper
} from '../../core/mixins';
import multiselect from 'vue-multiselect';
import Axios from 'axios';
import Loading from 'vue-loading-overlay';
import { config } from 'rxjs';
import moment from 'moment';
import DeleteConfirmation from '../../tracking/components/Geofences/DeleteConfirmation.vue';
import { JourneysService } from '../api/JourneysService';
import { dateTypes } from '../../core/models';

@Component({
    components: {
        Loading,
        Combobox,
        Button,
        DeleteConfirmation,
        ModalJourneyABM
    }
})
export default class JourneyActions extends Mixins(
    AuthStoreHelper,
    StoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    NotificationStoreHelper
) {
    @Prop({default: false}) visible: boolean;
    visibleModalForceCloseJourney: boolean = false;
    @Prop({default(){return []}}) selectedJourneys: Array<object>;
    modalTitle: string = 'Acciones';
    markAsProcessedOption: string = 'mark_as_processed';
    markAsUnProcessedOption:string = 'mark_as_unprocessed';
    markAsErrorOption: string = 'mark_as_error';
    unMarkAsErrorOption: string = 'unmark_as_error';
    forceCloseOption: string = 'force_close';
    restoreJourneyOption: string = 'restore_journey';
    deleteJourneysOption: string = 'delete_journey';
    defaultOptions: object = {
        mark_as_processed: {
        valid_journeys: [],
        invalid_journeys: [],
        tooltipError: ''
    },
    mark_as_unprocessed: {
        valid_journeys: [],
        invalid_journeys: [],
        tooltipError: ''
    },
    mark_as_error: {
        valid_journeys: [],
        invalid_journeys: [],
        tooltipError: ''
    },
    unmark_as_error: {
        valid_journeys: [],
        invalid_journeys: [],
        tooltipError: ''
    },
    force_close: {
        valid_journeys: [],
        invalid_journeys: [],
        tooltipError: ''
    },
    restore_journey: {
        valid_journeys: [],
        invalid_journeys: [],
        tooltipError: ''
    },
    delete_journey: {
        valid_journeys: [],
        invalid_journeys: [],
        tooltipError: ''
    }
    };
    journeysToProcess: object = this.defaultOptions;
    showTooltipMarkAsProcessed: boolean = false;
    showTooltipMarkAsUnProcessed: boolean = false;
    showTooltipMarkAsError: boolean = false;
    showTooltipUnMarkAsError: boolean = false;
    showTooltipForceClose: boolean = false;
    showTooltipRestoreJourney: boolean = false;
    showTooltipDeleteJourney: boolean = false;
    confirmJourneyAction: boolean = false;
    journeyActionTitle: string = '';
    journeyActionBody: string = '';
    currentAction: string = '';
    pendingMarkAsProcessed: boolean = false;
    pendingUnMarkAsProcessed: boolean = false;
    pendingMarkAsError: boolean = false;
    pendingUnMarkAsError: boolean = false;
    pendingForceClose: boolean = false;
    pendingRestoreJourney: boolean = false;
    pendingDeleteJourneys: boolean = false;
    journeysToClose: string[] = [''];

    //LoadingDialog
    pendingRequest: boolean = false;
    msgLoadingDialog: string = '';
    errorResponse: any = {};
    successPost: boolean | null = null;
    actualTimeStamp: any = getCurrentTime(dateTypes.dateFormatFromDisplayInfoNoSeconds)
    closeJourneyData: object = {
        width: '600',
        title: 'Forzar Cierre',
        form: {
            action: 'forzar-cierre'
        },
        warning: {
            icon: 'mdi-alert',
            text: '<b>ADVERTENCIA</b>: ESTA ACCIÓN NO PUEDE REVERTIRSE'
        },
        disclaimers: [
            'El cierre de la jornada se forzará en el último valor encendido al momento del cierre.',
            'En caso de que el vehículo se encuentre en movimiento, la jornada se cerrara \n en el momento solicitado  y se abrirá una nueva jornada.',
            'Si desea modificar la fecha de la jornada, debera realizar la modificación <br> luego de cerrada la misma.',
            'Fecha <b>tentativa</b> de cierre forzado de jornada: ' + '<b>' + this.actualTimeStamp + '</b>'
        ],
        isClosing: false,
        actions: [
            {
                name: 'Cancelar',
                color: 'error',
                action: 'close-modal'
            },
            {
                name: 'Forzar Cierre',
                color: 'green',
                action: 'forceCloseJourney'
            }
        ]
    }

    visibilityModalConfirmJourneyAction(value){
        this.confirmJourneyAction = value;
    }

    visibilityModalForceCloseJourney(value){
        this.visibleModalForceCloseJourney = value;
    }

    forceCloseJourneys(){
        this.visibilityModalForceCloseJourney(false);
        this.pendingLoadingDialog('Cerrando las jornadas...')
        this.loadingForceClose(true);
        let currentCompanyId:any = this.$_getSelectedCompanyById as number;
        let journeysIds = this.journeysToClose;
        JourneysService.postCloseJourney(
            {
                company_id: Number(currentCompanyId),
                journey_list: journeysIds
            }
        ).then((res) => {
            this.loadingForceClose(false);
            this.handleSuccessAction(res);
            this.updateJourneysInList(res, journeysIds);
        }).catch((err) => {
            this.loadingForceClose(false);
            this.handleErrorAction(err, 'No se pudieron cerrar las jornadas')
        })

    }

    pendingLoadingDialog(msg){
        this.$_showLoadingDialog(msg);
    }
    handleSuccessAction(response){
        this.$_successLoadingDialog({
            response: response
        });
    }
    handleErrorAction(error, alternative_msg){
        this.$_catchLoadingDialog({
            response: error.response.data || {},
            alternative_msg: alternative_msg
        });
    }

    showConfirmationModal(action){
        //este metodo muestra el modal de confirmación
        //mostrando las jornadas válidas de cada opcion
        this.currentAction = action;
        this.journeyActionBody = '¿Está seguro que desea ';
        let validJourneysList = this.getValidJourneysList(this.currentAction);
        switch(this.currentAction){
            case this.markAsProcessedOption:
                this.journeyActionTitle = 'Marcar como procesadas';
                this.journeyActionBody += 'marcar como procesadas las siguientes jornadas?<br>' + validJourneysList
                break;
            case this.markAsUnProcessedOption:
                this.journeyActionTitle = 'Marcar como NO procesadas';
                this.journeyActionBody += 'marcar como NO procesadas las siguientes jornadas?<br>' + validJourneysList
                break;
            case this.markAsErrorOption:
                this.journeyActionTitle = 'Marcar con error';
                this.journeyActionBody += 'marcar con error las siguientes jornadas?<br>' + validJourneysList
                break;
            case this.unMarkAsErrorOption:
                this.journeyActionTitle = 'Desmarcar con error';
                this.journeyActionBody += 'desmarcar con error las siguientes jornadas?<br>' + validJourneysList
                break;
            case this.forceCloseOption:
                this.journeyActionTitle = 'Forzar cierre';
                this.journeyActionBody += 'forzar el cierre de las siguientes jornadas?<br>' + validJourneysList
                break;
            case this.restoreJourneyOption:
                this.journeyActionTitle = 'Restaurar jornadas';
                this.journeyActionBody += 'deshacer la eliminación de las siguientes jornadas?<br>' + validJourneysList
                break;
            case this.deleteJourneysOption:
                this.journeyActionTitle = 'Eliminar jornadas';
                this.journeyActionBody += 'eliminar las siguientes jornadas?<br>' + validJourneysList
                break;

        }
        this.visibilityModalConfirmJourneyAction(true)

    }

    loadingPendingMarkAsProcessed(value){
        this.pendingMarkAsProcessed = value;
    }

    loadingPendingUnMarkAsProcessed(value){
        this.pendingUnMarkAsProcessed = value;
    }
    loadingPendingMarkAsError(value){
        this.pendingMarkAsError = value;
    }
    loadingUnMarkAsError(value){
        this.pendingUnMarkAsError = value;
    }
    loadingForceClose(value){
        this.pendingForceClose = value;
    }
    loadingRestoreJourneys(value){
        this.pendingRestoreJourney = value;
    }
    loadingDeleteJourneys(value){
        this.pendingDeleteJourneys = value;
    }

    processJourneys(data, validJourneysToSend){
        JourneysService.postProcessJourney(
            data
            ).then((res) => {
                this.handleSuccessAction(res);
                this.loadingPendingMarkAsProcessed(false);
                this.loadingPendingUnMarkAsProcessed(false);
                this.updateJourneysInList(res, validJourneysToSend)
            }).catch((err) => {
                this.loadingPendingMarkAsProcessed(false);
                this.loadingPendingUnMarkAsProcessed(false);
                this.handleErrorAction(err, 'No se pudieron procesar las jornadas');
            })
    }

    restoreJourneys(data, validJourneysToSend){
        JourneysService.restoreJourneyById(
            data
            ).then((res) => {
                this.handleSuccessAction(res);
                this.loadingPendingMarkAsProcessed(false)
                this.loadingRestoreJourneys(false);
                this.updateJourneysInList(res, validJourneysToSend)
            }).catch((err) => {
                this.loadingRestoreJourneys(false);
                this.handleErrorAction(err, 'No se pudieron restaurar las jornadas');
            })
    }

    deleteJourneys(data, validJourneysToSend){
        JourneysService.deleteJourneyById(
            data, false
            ).then((res) => {
                this.handleSuccessAction(res);
                this.loadingDeleteJourneys(false);
                this.updateJourneysInList(res, validJourneysToSend)
            }).catch((err) => {
                this.loadingDeleteJourneys(false);
                this.handleErrorAction(err, 'No se pudieron eliminar las jornadas');
            })
    }

    markJourneysError(data, validJourneysToSend){
        JourneysService.postMarkJourney(
            data
            ).then((res) => {
                this.handleSuccessAction(res);
                this.loadingPendingMarkAsError(false);
                this.loadingUnMarkAsError(false);
                this.updateJourneysInList(res, validJourneysToSend)
            }).catch((err) => {
                this.loadingPendingMarkAsError(false);
                this.loadingUnMarkAsError(false);
                this.handleErrorAction(err, 'No se pudieron marcar las jornadas con error');
            })
    }

    journeyAction(value){
        if(value){
            this.visibilityModalConfirmJourneyAction(false);
            this.journeysToClose = [''];
            let validJourneysToSend = this.journeysToProcess[this.currentAction]['valid_journeys'].map(function (item){
                return item['id']
            });
            let data = {
                journey_list: validJourneysToSend
            }
            switch(this.currentAction){
            //marcar como procesadas
            case this.markAsProcessedOption:
               this.pendingLoadingDialog('Marcando como procesadas...');
               this.loadingPendingMarkAsProcessed(true);
            //    console.log("marcar como procesadas");
               data['action'] = 'process';
               this.processJourneys(data, validJourneysToSend);
               break;
            case this.markAsUnProcessedOption:
                this.loadingPendingUnMarkAsProcessed(true);
                // console.log("marcar como NO procesadas");
                this.pendingLoadingDialog('Marcando como NO procesadas...');
                data['action'] = 'unprocess';
                this.processJourneys(data, validJourneysToSend);
                break;
            case this.markAsErrorOption:
                this.loadingPendingMarkAsError(true);
                // console.log("marcar con error");
                 this.pendingLoadingDialog('Marcando con error...');
                data['action'] = 'error';
                 this.markJourneysError(data, validJourneysToSend);
                break;
            case this.unMarkAsErrorOption:
                this.pendingLoadingDialog('Desmarcando con error...');
                data['action'] = 'noerror';
                this.loadingUnMarkAsError(true);
                this.markJourneysError(data, validJourneysToSend);
            //    console.log("desmarcar con error");
                break;
            case this.forceCloseOption:
                this.journeysToClose = validJourneysToSend
                this.visibilityModalForceCloseJourney(true);
                break;
            case this.restoreJourneyOption:
                this.loadingRestoreJourneys(true);
                this.pendingLoadingDialog('Restaurando las jornadas...');
                this.restoreJourneys(data, validJourneysToSend);
                break;
            case this.deleteJourneysOption:
                this.loadingDeleteJourneys(true);
                this.pendingLoadingDialog('Eliminando las jornadas...');
                this.deleteJourneys(data, validJourneysToSend);
                break;

        }

        }else{
           this.visibilityModalConfirmJourneyAction(false);
        }
    }

    @Emit()
    updateJourneysInList(res: object, journeysSent: string[]){}


    @Watch('selectedJourneys', {deep: true, immediate: true})
    observableSelectedJourneys(selectedJourneys){
        this.validateActions();
    }

    closeAllTooltips(){
        this.visibilityTooltipMarkAsProcessed(false);
        this.visibilityTooltipMarkAsUnProcessed(false);
        this.visibilityTooltipMarkAsError(false);
        this.visibilityTooltipUnMarkAsError(false);
        this.visibilityTooltipForceClose(false);
        this.visibilityTooltipRestoreJourney(false);
        this.visibilityTooltipDeleteJourney(false);
    }

    doNothing(){}


    submit() {
       
    }

    visibilityTooltipMarkAsProcessed(value){
        this.showTooltipMarkAsProcessed = value;
    }

    visibilityTooltipMarkAsUnProcessed(value){
        this.showTooltipMarkAsUnProcessed = value;
    }
    visibilityTooltipMarkAsError(value){
        this.showTooltipMarkAsError = value;
    }
    visibilityTooltipUnMarkAsError(value){
        this.showTooltipUnMarkAsError = value;
    }
    visibilityTooltipForceClose(value){
        this.showTooltipForceClose = value;
    }
    visibilityTooltipRestoreJourney(value){
        this.showTooltipRestoreJourney = value;
    }
    visibilityTooltipDeleteJourney(value){
        this.showTooltipDeleteJourney = value;
    }

    updateTooltipError(keyToUpdate: string, msg: string){
         this.journeysToProcess[keyToUpdate]['tooltipError'] = msg;
    }

    checkIfActionCanBeTriggered(currentOption: string){
        if(this.journeysToProcess[currentOption]['invalid_journeys'].length > 0){
            return false
        }
        if(!this.existSelectedJourneys){
            return false
        }
        return true
    }

    get userCanDeleteAndForceCloseJourney(): boolean{
        return this.$_checkPrivileges(PRIVILEGE_KEYS.JOURNEYS, PRIVILEGE_TYPES.EDIT_AND_DELETE);
    }

    get existSelectedJourneys(){
        if(this.selectedJourneys.length == 0){
            let msg = 'No hay jornadas seleccionadas';
            this.updateTooltipError(this.markAsProcessedOption, msg);
            this.updateTooltipError(this.markAsUnProcessedOption, msg);
            this.updateTooltipError(this.markAsErrorOption, msg);
            this.updateTooltipError(this.unMarkAsErrorOption, msg);
            this.updateTooltipError(this.forceCloseOption, msg);
            this.updateTooltipError(this.restoreJourneyOption, msg);
            this.updateTooltipError(this.deleteJourneysOption, msg);
            return false
        }
        return true
    }

    get canMarkAsProcessed(){
        return this.checkIfActionCanBeTriggered(this.markAsProcessedOption)
    }
    get canMarkAsUnProcessed(){
        return this.checkIfActionCanBeTriggered(this.markAsUnProcessedOption)
    }
    get canMarkAsError(){
        return this.checkIfActionCanBeTriggered(this.markAsErrorOption)
    }
    get canUnmarkAsError(){
        return this.checkIfActionCanBeTriggered(this.unMarkAsErrorOption)
    }
    get canForceClose(){
        return this.checkIfActionCanBeTriggered(this.forceCloseOption)
    }
    get canRestoreJourney(){
        return this.checkIfActionCanBeTriggered(this.restoreJourneyOption)
    }
    get canDeleteJourney(){
        return this.checkIfActionCanBeTriggered(this.deleteJourneysOption)
    }

    getLink(currentJourney: object, currentIndex){
        let baseUrl = process.env.VUE_APP_DOMAIN + 'journeys/information/' + currentJourney['id'];
        let driver = currentJourney['driver'] && currentJourney['driver']['name'] ?  currentJourney['driver']['name'] : currentJourney['driver']['id'];
        let buttonClass = 'caption mr-2';
        if(currentIndex !== -1){
            buttonClass += ' white--text'
        }
        let link = `<a href="${baseUrl}" class="${buttonClass}" target="_blank">${driver} - ${this.format(currentJourney['datetime_from'])},</a>`
        if(currentIndex){
            if ( currentIndex % 2 == 0 ) {      
                link += '<br>'
            }
        }
        return link
    }

    format(date: string) {
        return formatDate(date);
    }



    getValidJourneysList(key: string){
       return this.journeysToProcess[key]['valid_journeys'].map((journey, index) => {
                return this.getLink(journey, -1)
        }).join('')
    }

    getInvalidJourneysList(key: string){
        return this.journeysToProcess[key]['invalid_journeys'].map((journey, index) => {
                return this.getLink(journey, index)
        }).join('')
    }

    pushInvalidJourneyToList(journey: object, key: string){
        this.journeysToProcess[key]['invalid_journeys'].push(journey)
    }

    pushValidJourneyToList(journey: object, key: string){
        this.journeysToProcess[key]['valid_journeys'].push(journey)
    }

    clearPreviousValidations(){
        this.journeysToProcess = JSON.parse(JSON.stringify(this.defaultOptions));
    }

    checkIfJourneyCanBeMarkAsProcessed(currentJourney:object, isClosed: boolean, isProcessed: boolean){
        if(!isClosed || isProcessed){
            this.addInvalidJourneyTooltip(currentJourney, 'Las siguientes jornadas están en curso o ya fueron procesadas:<br> ', this.markAsProcessedOption);
        }
        if(isClosed || !isProcessed){
            this.pushValidJourneyToList(currentJourney, this.markAsProcessedOption)
        }
    }

    checkIfJourneyCanBeMarkAsUnProcessed(currentJourney:object, isProcessed: boolean){
        if(isProcessed){
            //si la jornada esta procesada
            //la puedo desmarcar
            this.pushValidJourneyToList(currentJourney, this.markAsUnProcessedOption);
        }else{
            //sino
            //no la puedo desmarcar
            this.addInvalidJourneyTooltip(currentJourney, 'Las siguientes jornadas no están Marcadas como procesadas: <br> ', this.markAsUnProcessedOption);

        }
    }

    addInvalidJourneyTooltip(currentJourney:object, msg: string, currentKey:string){
        this.pushInvalidJourneyToList(currentJourney, currentKey);
        let message = msg + this.getInvalidJourneysList(currentKey)
        this.updateTooltipError(currentKey, message);
    }

    checkIfJourneyCanBeMarkAsError(currentJourney:object, hasError: boolean){
        //compruebo si la jornada está marcada con error
        if(hasError){
            //si la jornada fue marcada con error
            //No se puede "marcar" de nuevo
            this.addInvalidJourneyTooltip(currentJourney, 'Las siguientes jornadas ya están marcadas con error<br> ', this.markAsErrorOption);

            //pero si se puede desmarcar
            this.pushValidJourneyToList(currentJourney, this.unMarkAsErrorOption);
        }else{
            //si la jornada no fue marcada con error
            //puedo marcarla
            this.pushValidJourneyToList(currentJourney, this.markAsErrorOption);

            // pero no puedo desmarcarla
            this.addInvalidJourneyTooltip(currentJourney, 'Las siguientes jornadas no están marcadas con error<br> ', this.unMarkAsErrorOption);
        }
    }

    checkIfJourneyCanBeClosed(currentJourney:object, isClosed: boolean){
        if(currentJourney['closing']){
            //si la jornada está en proceso de cierre
            //no la puedo volver a cerrar
            this.addInvalidJourneyTooltip(currentJourney, 'Las siguientes jornadas están en proceso de cierre:<br> ', this.forceCloseOption);
        }else{
            //sino
            if(isClosed){
                //si la jornada está cerrada
                //no la puedo cerrar
                this.addInvalidJourneyTooltip(currentJourney, 'Las siguientes jornadas ya están cerradas:<br> ', this.forceCloseOption);

            }else{
                //la puedo cerrar porque está en curso
                this.pushValidJourneyToList(currentJourney, this.forceCloseOption);
            }
        }
    }

    checkIfJourneyCanBeRestored(currentJourney: object, currentJourneyIsDeleted: boolean){
        if(currentJourneyIsDeleted){
            //si la jornada está eliminada, la puedo restaurar
            this.pushValidJourneyToList(currentJourney, this.restoreJourneyOption);
        }else{
            //sino no puedo restaurarla
            this.addInvalidJourneyTooltip(currentJourney, 'Las siguientes jornadas no están eliminadas:<br> ', this.restoreJourneyOption);
        }
    }

    checkIfJourneyCanBeDeleted(currentJourney: object, currentJourneyIsClosed: boolean, currentJourneyIsDeleted: boolean){
        if(currentJourneyIsClosed && !currentJourneyIsDeleted){   
            //si la jornada está cerrada y no está eliminada
            //la puedo eliminar
            this.pushValidJourneyToList(currentJourney, this.deleteJourneysOption);
        }else{
            this.addInvalidJourneyTooltip(currentJourney, 'Las siguientes jornadas están en curso o eliminadas<br>', this.deleteJourneysOption);
        }
    }

    validateActions(){
        this.clearPreviousValidations();

        for(let i=0; i<this.selectedJourneys.length; i++){
            let currentSelectedJourney = this.selectedJourneys[i];
            let currentJourneyIsClosed = currentSelectedJourney['datetime_to'] !== null ? true : false;
            let currentJourneyIsDeleted = currentSelectedJourney['deleted'];
            let currentJourneyIsProcesed = currentSelectedJourney['processed'];
            let currentJourneyHasError = currentSelectedJourney['error'];

            //compruebo si la jornada actual puede "marcarse como procesada";
            this.checkIfJourneyCanBeMarkAsProcessed(currentSelectedJourney, currentJourneyIsClosed, currentJourneyIsProcesed);
            
            //checkeo si las jornadas pueden marcarse como "NO" procesadas
            this.checkIfJourneyCanBeMarkAsUnProcessed(currentSelectedJourney, currentJourneyIsProcesed)

            //checkeo si la jornada puede marcarse/desmarcarse con error
            this.checkIfJourneyCanBeMarkAsError(currentSelectedJourney, currentJourneyHasError);

            //checkeo si se puede forzar el cierre
            this.checkIfJourneyCanBeClosed(currentSelectedJourney, currentJourneyIsClosed);

            //checkeo si la jornada se puede restaurar
            this.checkIfJourneyCanBeRestored(currentSelectedJourney, currentJourneyIsDeleted);

            //checkeo si la jornada se puede eliminar
            this.checkIfJourneyCanBeDeleted(currentSelectedJourney, currentJourneyIsClosed, currentJourneyIsDeleted);

        }
    }



   

    

   
    @Emit()
    closeModal() {}

    mounted() {
        // this.$nextTick(() => {
            
        // });
    }
}
